<template>
  <MarketplaceProductPage :product-id="id" />
</template>

<script setup lang="ts">
definePageMeta({
  allowBack: true,
})
const route = useRoute()

const id = Array.isArray(route.params.productId)
  ? Number(route.params.productId[0])
  : Number(route.params.productId)
</script>
